import { hasPermission } from '@ubisend/pulse-auth';

import { Subscribers } from './Pages/index';

const routes = [
  {
    name: 'Conversations',
    path: '/conversations/:id?',
    component: Subscribers,
    canAccess: hasPermission('view subscribers'),
    actions: [
      {
        title: 'See all chat transcripts',
        description: 'Read your chatbot interactions.',
        icon: 'chat'
      }
    ]
  }
];

export default routes;
